import { Factory } from 'rosie';

Factory.define('Integration');

Factory.define('IntegrationWithDefaults')
  .extend('Integration')
  .attr('id', 'integration-1')
  .attr('name', 'My First Integration')
  .attr('enabled', true);
